<template>
	<modal :show="!!open" @close="close" size="lg">
		<div>
			<div class="row align-items-center">
				<div class="col-md-3 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-3 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-3 col-12 search">
					<base-button type="default" @click="getTransactions()" :disabled="loading">
						ค้นหา
					</base-button>
				</div>
			</div>

			<el-table class="mt-3" row-key="id" header-row-class-name="thead-light" :data="queriedData">
				<el-table-column label="จาก" min-width="80px">
					<div slot-scope="{ row }">
						{{ row.fromAccount }}
					</div>
				</el-table-column>
				<el-table-column label="ไปยัง" min-width="100px">
					<div slot-scope="{ row }">
						{{ row.toAccount }}
					</div>
				</el-table-column>
				<el-table-column label="จำนวน" min-width="120px">
					<div slot-scope="{ row }">
						<b>{{ row.amount | format(2) }}</b> บาท
						<small class="d-block mb-0">
							คงเหลือ <b>{{ row.afterBalance | format(2) }}</b> บาท
						</small>
					</div>
				</el-table-column>
				<el-table-column label="เวลา" min-width="120px">
					<div slot-scope="{ row }">
						{{ row.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}
					</div>
				</el-table-column>
				<el-table-column min-width="50px">
					<div slot-scope="{ row }">
						<base-button type="primary" size="sm" @click="viewQR(row.qrString)" v-if="row.qrString">
							<i class="fas fa-qrcode" />
						</base-button>
					</div>
				</el-table-column>
			</el-table>
			<div class="card-footer d-flex justify-content-between">
				<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

				<base-pagination
					class="pagination-no-border"
					:per-page="pagination.perPage"
					:total="total"
					v-model="pagination.currentPage"
				/>
			</div>
		</div>
	</modal>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import moment from 'moment'
import SettingService from '../../services/setting.service'
import tablePagination from '../../mixins/tablePagination'
import QRCode from 'davidshimjs-qrcodejs'
import Swal from 'sweetalert2'

export default {
	props: ['open'],
	mixins: [tablePagination([], 10)],
	components: {
		flatPicker,
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			loading: false,

			startDate: moment()
				.add(-7, 'days')
				.format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		viewQR(qrString) {
			Swal.fire({
				html: `<div class="d-flex justify-content-center">
					<div id="qr" class="ml--2"></div>
				</div>`,
			})

			const qr = new QRCode(document.getElementById('qr'), {
				width: 175,
				height: 175,
			})
			qr.clear()
			qr.makeCode(qrString)
		},
		getTransactions() {
			this.loading = true
			SettingService.getAllSCBAutoTx({
				start: this.startDate,
				end: this.endDate,
			})
				.then((res) => {
					this.updateTableData(res)
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	watch: {
		open(v) {
			if (v) {
				this.updateTableData([])
				this.getTransactions()
			}
		},
	},
}
</script>
